
let yourConfig = { headers: { Authorization: "Bearer " + localStorage.getItem("authToken") } }
console.log('yourConfig file ip', yourConfig)

const hostgicserveur ='https://fsc-integration.svom.org/gic-web/gic-web/gic-server'
//const hostgicserveur ='http://server:5001'
//const hostgicserveur ='http://127.0.0.1:5001'

module.exports = {
  getHost: function () {
    return hostgicserveur;
  }

};

          